/* eslint-disable no-console,no-undef, camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import HealthDataManagement from '../../components/HealthDataManagement';
import CustomizeDashboard from '../../components/HealthDataManagement/customizeddashboard';

class HealthManagement extends Component {

  healthDataManagement = () => (
    <HealthDataManagement companyInfo={this.props.companyInfo} history={this.props.history} companyLogo={this.props.companyLogo}/>
  );

  customizeDashboard = () => (
    <CustomizeDashboard companyInfo={this.props.companyInfo} history={this.props.history} companyLogo={this.props.companyLogo} companyId={this.props.companyInfo?.id}/>
  );

  render() {
    return (
      <Switch>
        <Route path="/company/health" render={this.healthDataManagement} exact={true} />
        <Route path="/company/health/customize" render={this.customizeDashboard} exact={true} />
      </Switch>
    )
  }
}

HealthManagement.propTypes = {
  history: PropTypes.object.isRequired,
  companyInfo: PropTypes.object,
  companyLogo: PropTypes.object
};

export default connect(null, null)(HealthManagement);

